import { OrderBookingRptService }  from '../services';
import  { OrderBookingRptConstants }  from '../constants';
import {alertActions} from '.';

export const OrderBookingRptActions = {
    getAll,
    loadingData,
    exportData
};

function getAll(obj)
{
    return dispatch =>{
        dispatch(request());

        OrderBookingRptService.fetchOrderBookingData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))


            var data = response.ResponseData;   //Changes
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }            
            dispatch(successExport(data))
        },
        error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        }
        
        );
    };
    function request() { return { type : OrderBookingRptConstants.GETALL_REQUEST } }       //Changes
    function success(datas) { return { type: OrderBookingRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: OrderBookingRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: OrderBookingRptConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        OrderBookingRptService.fetchOrderBookingData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows});
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: OrderBookingRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: OrderBookingRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: OrderBookingRptConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: OrderBookingRptConstants.LOADING_REQUEST, isbool
    }
}

